import { blue, deepPurple, grey, lightBlue } from "@mui/material/colors";

export const getWeatherDescription = (code) => {
  switch (code) {
    case 0:
      return "Céu limpo";
    case 1:
      return "Poucas Nuvens";
    case 2:
      return "Parcialmente nublado";
    case 3:
      return "Nublado";
    case 45:
      return "Neblina";
    case 51:
      return "Chuva leve";
    case 53:
      return "Chuva moderada";
    case 61:
      return "Chuvas";
    case 71:
      return "Chuva de neve";
    case 81:
      return "Neve";
    case 95:
      return "Trovoada";
    default:
      return "Desconhecido";
  }
};

export const getWeatherBackgroundColor = (weathercode) => {
  switch (weathercode) {
    case 0: // Clear sky
      return lightBlue["200"];
    case 1: // Mainly clear
      return blue["200"];
    case 2: // Partly cloudy
      return grey["200"];
    case 3: // Overcast
      return grey["400"];
    case 45: // Fog
      return grey["600"];
    case 48: // Depositing rime fog
      return grey["700"];
    case 51: // Light drizzle
    case 53: // Moderate drizzle
    case 55: // Dense drizzle
      return lightBlue["100"];
    case 61: // Slight rain
    case 63: // Moderate rain
    case 65: // Heavy rain
      return blue["300"];
    case 95: // Thunderstorm
    case 96: // Thunderstorm with slight hail
    case 99: // Thunderstorm with heavy hail
      return deepPurple["300"];
    default:
      return grey["200"]; // Default color
  }
};
